// theme.ts — dashboard theme: light / dark / system (Johnny 2026-08-05: manual toggle
// pulled forward from the M5-settings plan). `.dark` on <html> is what globals.css's
// @custom-variant keys off. "system" = no stored override, follow the OS live.
export type ThemePreference = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'embent:theme';
const query = window.matchMedia('(prefers-color-scheme: dark)');

export function getThemePreference(): ThemePreference {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'system';
}

function apply(pref: ThemePreference): void {
  const dark = pref === 'dark' || (pref === 'system' && query.matches);
  document.documentElement.classList.toggle('dark', dark);
}

export function setThemePreference(pref: ThemePreference): void {
  if (pref === 'system') localStorage.removeItem(STORAGE_KEY);
  else localStorage.setItem(STORAGE_KEY, pref);
  apply(pref);
}

/** Call once at boot: applies the stored preference and tracks OS changes while in
 * "system" mode. */
export function initTheme(): void {
  apply(getThemePreference());
  query.addEventListener('change', () => {
    if (getThemePreference() === 'system') apply('system');
  });
}
